import { Injectable } from '@angular/core';
import {HttpInterceptor,HttpClient, HttpHeaders, HttpResponse, HttpErrorResponse,HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import {LogserviceService} from '../logservice/logservice.service';


const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Cache-Control': 'private, max-age=1200'
  })
};
const headers = new HttpHeaders().set('Content-Type', 'text/plain; charset=utf-8');
@Injectable({
  providedIn: 'root'
})
export class ObjectController {
  
  constructor(private httpClient:HttpClient ,private logService:LogserviceService) { }
  httpHeaders = new HttpHeaders();

  backendUrl = environment.apiURL;

  getObjectData(id:number,objectname:string){
    return this.httpClient.get(this.backendUrl+'entity/'+objectname+'/'+id, {
      headers: this.httpHeaders
    }).pipe(retry(2), catchError(this.handleError));
  }
  getPersonData(id:number){
    return this.httpClient.get(this.backendUrl+'entity/Person/'+id, {
      headers: this.httpHeaders
    }).pipe(retry(2), catchError(this.handleError));
  }
  onSaveObject(payload:any):Observable<any> {
    return this.httpClient.post(this.backendUrl+'page/entity/customcreate', payload, httpOptions
    ).pipe(catchError(this.handleError));
  }
  entityCreate(payload:any):Observable<any> {
    return this.httpClient.post(this.backendUrl+'page/entity/create', payload, httpOptions);
  }
  queryReportCreate(payload:any):Observable<any> {
    return this.httpClient.post(this.backendUrl+'entity/create', payload, httpOptions);
  }
  queryReportMultiUpdate(payload:any):Observable<any> {
    return this.httpClient.post(this.backendUrl+'page/entity/multiedit', payload, httpOptions);
  }
  createContact(payload:any):Observable<any> {
    return this.httpClient.post(this.backendUrl+'customContactCreate', payload, httpOptions);
  }
  reportFormCreate(payload:any):Observable<any> {
    return this.httpClient.post(this.backendUrl+'entity/fromreport/create', payload, httpOptions);
  }
  getTriageStatus(id:number):Observable<any> {
    return this.httpClient.get(this.backendUrl+'getTriageStatus/'+id, {
      headers: this.httpHeaders
    }).pipe(retry(2), catchError(this.handleError));
  }
  getLookupName(id,enityName): Observable<any>{
    return this.httpClient.get(this.backendUrl + 'page/entity/lookup/'+enityName+'/'+id,{ headers, responseType: 'text'});
   }
  private handleError(errorObj: HttpErrorResponse | any) {
    const _self = this;
    let errorMessage: string;
    let body: any;
    if (errorObj instanceof HttpErrorResponse) {
      if (errorObj.ok === false && errorObj.status === 0) {
        errorMessage = 'No internet connection or server might be unreachable. Please try again after sometime. ObjectDetails';
      } else {
        body = errorObj.error || '';
        errorMessage = body.message ? body.message : body.error.message;
      }
    }
    return throwError(errorMessage);
  }
  
}
